import PosthogService from '~/services/posthog/PosthogService';

export function fireReportIncidentWalkOutClicked(): void {
  PosthogService.getInstance().track('dental_portal:report_incident:walk_out_clicked');
}
